import { useQuery } from '@tanstack/react-query';
import { getProviderLicenseStates } from '@uplift/api';
import { providerQueryKeys } from './providerQueryKeys';

export const useProviderLicenseStatesQuery = (providerId: string, availableOnly = true) => {
  return useQuery({
    queryKey: providerQueryKeys.licenseStates(providerId),
    queryFn: async () => {
      const response = await getProviderLicenseStates(providerId, availableOnly);

      return response.data;
    }
  });
};
